
import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AnalyticsService, AuthService, ToastConfigService, UtilityService } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';


import { APP_SETTINGS } from '@services';
import { SharedService } from './shared.service';
import { NgFor, NgStyle } from '@angular/common';

@Component({
    selector: 'app-share-content',
    templateUrl: './share-content.component.html',
    styleUrls: ['./share-content.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        NgFor,
        NgStyle,
    ],
})
export class ShareContentComponent implements OnInit, OnDestroy {

  @Input() shareContent: any;

  public userEmails: string[];
  username: string;
  public userForm = new UntypedFormGroup({});
  public body = new UntypedFormControl('');
  public email = new UntypedFormControl('', Validators.required);
  emails: any[] = [];
  private subscriptions: ISubscription[];
  makeName: string;
  APP_SETTINGS : any;
  private selectedBranch = ''; //ASENGG-29541 Share links brand issue fix
  constructor(
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private sharedService: SharedService,
    private toastService: ToastConfigService,
    private analyticsService: AnalyticsService,
    private utilityService: UtilityService
  ) { }

  get formData() { return <UntypedFormArray>this.userForm.get('emails'); }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.subscriptions = [];
    this.username = this.authService.getUserName();
    this.userForm = this.fb.group({
      body: this.body,
      emails: this.fb.array([this.fb.group({
        email: new UntypedFormControl('', Validators.required)
      })])
    });
  }

  public addNewEmail(): void {
    const control = <UntypedFormArray>this.userForm.controls.emails;
    control.push(
      this.fb.group({
        email: new UntypedFormControl('', Validators.required)
      })
    );
  }

  onSubmit(form) {
        if (this.shareContent['type'] === 'bulletin' && (this.shareContent['bulletinType'] === 'sib' || this.shareContent['bulletinType'] === 'SIB')) {
      //Analytics Call
      this.analyticsService.trackSharedContentByTypeLineMake('Service Bulletins', this.shareContent['bulletinDisplayNumber'], 'shared');
    }
    else if (this.shareContent['type'] === 'bulletin' && (this.shareContent['bulletinType'] == 'tri' || this.shareContent['bulletinType'] === 'TRI')) {
      //Analytics Call
      this.analyticsService.trackSharedContentByTypeLineMake('TRI Bulletins', this.shareContent['bulletinDisplayNumber'], 'shared');
    }
    else if (this.shareContent['type'] === 'video') {
      //Analytics Call
      this.analyticsService.trackSharedContentByTypeLineMake('Videos', this.shareContent['videoDisplayNumber'], 'shared');
    }
    this.utilityService.closeShareContentPopup(true);
    this.makeName = APP_SETTINGS.isBMW ? 'BMW' : 'MINI';
    let baseUrl =  window.location.origin + window.location.pathname;
    
    const url = this.shareContent['type'] === 'video' ?
      `playback?channel=${this.shareContent['channel']}&video=${this.shareContent['id']}&watchlist=false` :
      `bulletin/${this.shareContent['id']}?type=${this.shareContent['bulletinType']}`;

    form.value.emails.map(emailInfo => {
      if (emailInfo.email.trim() !== '') {
        this.emails.push(emailInfo.email);
      }
    });

    let emailBodyText = 'Message blank';
    if (this.body.value == null || this.body.value == undefined || this.body.value.length == 0) {
      emailBodyText = 'Message blank';
    } else {
      emailBodyText = this.body.value;
    }

    //ASENGG-29541 Share links Brand Issue Fix
    if (APP_SETTINGS.isBMW === "true") {
      this.selectedBranch="BMW";  
    }
    if (APP_SETTINGS.isMINI === "true") {
      this.selectedBranch="MINI";
    }
    if (APP_SETTINGS.isMOTORRAD === "true") {
      this.selectedBranch="MOTORRAD";
    }
    if (APP_SETTINGS.isRollsRoyce === "true") {
      this.selectedBranch="ROLLSROYCE";
    }

    this.shareContent = {
      'emailBody': emailBodyText,
      'emailList': this.emails,
      'shareLinkURL': baseUrl + encodeURIComponent('#/' + url),
      'make': this.selectedBranch //ASENGG-29541 Share links Brand Issue Fix
    };
    //ASENGG-29541 Share links content brand issue fix
    this.subscriptions.push(this.sharedService.shareContent((this.shareContent)).subscribe(data => {
      this.emails = [];
    }, err => {
      this.emails = [];
    }));
  }
  ngOnDestroy(): void {
    this.subscriptions.map(s => s.unsubscribe());
  }

}
